import { Invoice } from '../../types';
import { delay } from '../mock/delay';
import { mockInvoices } from '../mock/invoices';

export const invoiceService = {
  getList: async (filters?: {
    invoiceNumber?: string;
    patientName?: string;
    service?: string;
    startDate?: string;
    endDate?: string;
  }): Promise<Invoice[]> => {
    await delay(500);
    let filtered = [...mockInvoices];
    
    if (filters?.invoiceNumber) {
      filtered = filtered.filter((i) => i.invoiceNumber.includes(filters.invoiceNumber!));
    }
    if (filters?.patientName) {
      filtered = filtered.filter((i) => i.customerName.includes(filters.patientName!));
    }
    if (filters?.service) {
      filtered = filtered.filter((i) => i.service.includes(filters.service!));
    }
    if (filters?.startDate) {
      filtered = filtered.filter((i) => i.createdAt >= filters.startDate!);
    }
    if (filters?.endDate) {
      filtered = filtered.filter((i) => i.createdAt <= filters.endDate!);
    }
    
    return filtered;
  },

  getDetail: async (id: string): Promise<Invoice> => {
    await delay(300);
    const invoice = mockInvoices.find((i) => i.id === id);
    if (!invoice) {
      throw new Error('Invoice not found');
    }
    return invoice;
  },
};

